import { z } from "zod";

const Artifact = z.object({
  id: z.string(),
  createdAt: z.coerce.date(),
  projectIterationId: z.string(),
});

export const ForgeFileArtifact = Artifact.extend({
  type: z.enum(["file/text", "file/pdf", "file/image"]),
  fileName: z.string(),
  uploadedFileUrl: z.string(),
});

export const ForgeFigmaArtifact = Artifact.extend({
  type: z.literal("figma/node"),
  figmaFileUrl: z.string(),
  figmaNodeId: z.string(),
  figmaFileName: z.string().optional(),
  previewUrl: z.string().optional(),
});

export const ForgeSpecArtifact = Artifact.extend({
  type: z.literal("spec"),
  fileName: z.string(),
  yjsDocId: z.string(),
  markdownText: z.string(),
});

export const ForgeBuildArtifactFiles = z.array(
  z.object({
    path: z.string(),
    content: z.string(),
    isVisibleToUser: z.boolean().optional(),
  })
);

export const ForgeBuildArtifactEnvironment = z.object({
  dependencies: z.record(z.string()),
});

export const ForgeBuildArtifact = Artifact.extend({
  type: z.literal("build"),
  participantId: z.string(),
  files: ForgeBuildArtifactFiles,
  environment: ForgeBuildArtifactEnvironment,
});

export const ForgeArtifact = z.union([ForgeBuildArtifact, ForgeSpecArtifact, ForgeFigmaArtifact, ForgeFileArtifact]);

// TypeScript types
export type ForgeFileArtifact = z.infer<typeof ForgeFileArtifact>;
export type ForgeFigmaArtifact = z.infer<typeof ForgeFigmaArtifact>;
export type ForgeSpecArtifact = z.infer<typeof ForgeSpecArtifact>;
export type ForgeBuildArtifact = z.infer<typeof ForgeBuildArtifact>;
export type ForgeArtifact = z.infer<typeof ForgeArtifact>;
